import { Spinner, SpinnerColor } from './Spinner';

export const GeneralSpinner = () => (
  <Spinner spinnerColor={SpinnerColor.Blue} width='32px' height='32px' />
);
